import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/shared/services/api.service';
import {
  MachineReservationFormDialogComponent,
  MachineReservationDialogData,
} from '../machine-reservation-form-dialog/machine-reservation-form-dialog.component';

@Component({
  selector: 'app-machine-master',
  templateUrl: './machine-master.component.html',
  styleUrl: './machine-master.component.css'
})
export class MachineMasterComponent {
 
  machineList:any[]=[];
  

  displayedColumns: string[] = ['srNo', 
  // "equipment_id",
  "equipment_code",
  "equipment_name",
  "category",
  // "capacity",
  // "specification",
  "operational_status",
  "action"
  ];
  dataSource = new MatTableDataSource([]);
  searchKeyword = "";
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(
    private readonly apiService: ApiService,
    private router: Router,
    private toastrMsgService: ToastrService,
    private dialog: MatDialog){
    
  }
  
  ngAfterViewInit() {
    this.fetchData();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  onStatusChange(event: any) {
    // const status = event.value;
    const status = (event.target as HTMLSelectElement).value;

    this.dataSource.data = status
      ? this.machineList.filter(machine => machine.status === status)
      : this.machineList as any;
  }


  /** Row label for STATUS column (DB: operational_status). */
  machineStatusLabel(m: Record<string, unknown> | null | undefined): string {
    const raw =
      (m?.['operational_status'] ?? m?.['operationalStatus'] ?? m?.['status']) as
        | string
        | undefined;
    const s = raw != null ? String(raw).trim() : '';
    return s || '—';
  }

  activeMachineCount(): number {
    return (this.dataSource.data as Record<string, unknown>[]).filter((m) => {
      const status = this.machineStatusLabel(m).toUpperCase();
      return status.includes('OPERAT') || status === 'ACTIVE';
    }).length;
  }

  machineStatusBadgeClass(m: Record<string, unknown> | null | undefined): string {
    const s = this.machineStatusLabel(m).toUpperCase();
    if (s === '—') return 'bg-gray-100 text-gray-800';
    if (s.includes('OPERAT') || s === 'ACTIVE') return 'bg-green-100 text-green-800';
    if (s.includes('MAINT') || s.includes('IDLE') || s.includes('STANDBY')) {
      return 'bg-amber-100 text-amber-800';
    }
    if (
      s.includes('DOWN') ||
      s.includes('INACTIVE') ||
      s.includes('RETIRED') ||
      s.includes('NON')
    ) {
      return 'bg-red-100 text-red-800';
    }
    return 'bg-gray-100 text-gray-800';
  }

  fetchData() {
    this.apiService.getMachineMaster().subscribe({
      next: (res: any) => {
        const rows = Array.isArray(res) ? res : res?.data ?? [];
        this.machineList = rows;
        this.dataSource.data = rows;
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.errorMessage ?? err?.error?.error ?? 'Failed to load machines');
      },
    });
  }

  openReservations(machine?: any): void {
    if (machine?.id) {
      void this.router.navigate(['/home/machine-reservations'], { queryParams: { machine_id: machine.id } });
      return;
    }
    void this.router.navigate(['/home/machine-reservations']);
  }

  bookMachine(machine: any): void {
    this.dialog.open(MachineReservationFormDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: 'first-tabbable',
      panelClass: 'machine-reservation-dialog',
      data: { prefillMachineId: machine.id } as MachineReservationDialogData,
    });
  }
}